import { Vue } from "vue-class-component";

export default class Layout extends Vue {
}

